<ng-container *ngIf="!loadingSpinnerOnly">
  <lib-spacer></lib-spacer>

  <div class="clickable-container" (click)="openLanguageDialog()">
    <img
      class="flag-icon"
      alt="{{ selectedLanguage.countryCode }}"
      src="/assets/svg-country-flags/{{
        selectedLanguage.countryCode.toLowerCase()
      }}.svg"
    />
    <span>{{
      'pipes.language.' + selectedLanguage.languageCode | translate
    }}</span>
  </div>

  <lib-spacer></lib-spacer>
</ng-container>

<div class="container">
  <ng-container *ngIf="!loadingSpinnerOnly; else loadingSpinner">
    <ng-content></ng-content>
  </ng-container>

  <ng-template #loadingSpinner>
    <div class="loading-spinner-wrapper">
      <div>{{ 'process-container.text.page-loading' | translate }} ...</div>

      <lib-spacer></lib-spacer>

      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-template>
</div>

<ng-container
  *ngIf="!loadingSpinnerOnly && !(iframeService.iframeModeEnabled$ | async)"
>
  <lib-spacer></lib-spacer>

  <div class="clickable-container" (click)="navigateToPublicHomePage()">
    <mat-icon>arrow_back</mat-icon>
    <span>{{ 'process-container.text.back-to-home' | translate }}</span>
  </div>

  <lib-spacer></lib-spacer>
</ng-container>
